import {internalApi} from "../../../common/axios";
import {useMutationBase, useQueryBase} from "../../../shared/hooks/useHookBase";

const fetchCharacterPackage = async () => {
    const {data} = await internalApi.get(`store_manager/characterPackage`);
    return data.rows;
}

export const useCharacterPackage = () => {
    return useQueryBase(['characterPackage'], fetchCharacterPackage);
}

const saveCharacterPackage = async (packageData) => {
    await internalApi.post(`store_manager/characterPackage`, {data: packageData});
}

export const useSaveCharacterPackage = () => {
    return useMutationBase('characterPackage', saveCharacterPackage);
}

const deleteCharacterPackage = async (seq) => {
    await internalApi.delete(`store_manager/characterPackage`, {params: {seq}});
}

export const useDeleteCharacterPackage = () => {
    return useMutationBase('characterPackage', deleteCharacterPackage);
}

const fetchMiniGame = async () => {
    const {data} = await internalApi.get('store_manager/miniGame');
    return data.rows;
}

export const useMiniGame = () => {
    return useQueryBase(['miniGame'], fetchMiniGame);
}

const saveMiniGame = async (miniGameData) => {
    await internalApi.post(`store_manager/miniGame`, {data: miniGameData});
}

export const useSaveMiniGame = () => {
    return useMutationBase('miniGame' ,saveMiniGame);
}

const deleteMiniGame = async (seq) => {
    await internalApi.delete(`store_manager/miniGame`, {params: {seq}});
}

export const useDeleteMiniGame = () => {
    return useMutationBase('miniGame', deleteMiniGame);
}